import React from "react";
import {AEmptyState} from "@cisco-sbg-ui/magna-react";
import css from "./NotFound404.module.scss";

const NotFound404 = () => {
  return (
    <div className={css.parent} data-testid="NotFound404">
      <div className={css.child}>
        <AEmptyState variant="danger" />
      </div>
      <p className={css.child}>
        <b>404 Error!</b>
      </p>
      <p className={css.child}>The requested page was not found.</p>
    </div>
  );
};

export default NotFound404;
